import { css } from '@fluentui/react';
export var getStylesByType = function (type, dataGridColumnProcessedStyle) {
    switch (type) {
        case 'number':
        case 'currency':
            return css(dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.fontProperties, dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.textColor, dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.alignRight);
        case 'date':
        case 'dayjs':
            return css(dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.fontProperties, dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.alignRight);
        case 'boolean':
        case 'string':
        case 'CrmLookUpType':
        case 'CrmOptionSet':
        case 'text':
        case 'primaryText':
            return css(dataGridColumnProcessedStyle.fontProperties, dataGridColumnProcessedStyle.textColor, dataGridColumnProcessedStyle.alignLeft);
        case 'iconText':
            return css(dataGridColumnProcessedStyle.fontProperties, dataGridColumnProcessedStyle.textColor, dataGridColumnProcessedStyle.leftAlignedCellContainer);
        case 'status':
            return css(dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.fontProperties, dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.alignLeft);
        case 'link':
        case 'secondaryLink':
        case 'persona':
            return css(dataGridColumnProcessedStyle === null || dataGridColumnProcessedStyle === void 0 ? void 0 : dataGridColumnProcessedStyle.leftAlignedCellContainer);
        default:
            return null;
    }
};
//# sourceMappingURL=DataGridColumnBlank.utilities.js.map